import { createProvider } from '@nvision/services/data-provider';
import { normalizeWeightUomList } from '@views/screens/common/data-provider/weight-uom-list/normalize';

import * as api from './api';

export const fetchWeightUomList = createProvider(api.fetchWeightUomList)
  .andThen((res) => normalizeWeightUomList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
